import axios from '@/utilities/axios-global'

export function GET_REPORTS(context) {
  return new Promise((resolve, reject) => {
    if (context.state.reports.length > 0) {
      resolve()
      return
    }
    axios.get(context.rootState.user.baseApiUrl + `/reports`).then((response) => {
      context.commit('SET_REPORTS', response.data)
      resolve()
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export function GENERATE_REPORT(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post(context.rootState.user.baseApiUrl + `/reports?startDate=${payload.startDate}&endDate=${payload.endDate}`, payload.body, { responseType: 'arraybuffer' }).then((response) => {
      resolve(response)
    }, error => {
      console.log(error)
      reject(error)
    })
  })
}

export default {
  GET_REPORTS,
  GENERATE_REPORT
}
